import { initPaymentPage } from 'payment_page';

document.addEventListener('DOMContentLoaded', () => {
  initPaymentPage();
});
